import { Metamodel } from 'app/model/base/model';
import { format } from 'app/shared/utils/string.util';
import { IModel } from 'app/model/base/annotation';
import { LinkedService } from './linkedservice';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { AzureKeyVault } from './key-vault';
import { IAttribute } from 'shell-models-lib';

export const fabricAuthTypes = {
    ServicePrincipalAuthentication: 'AadServicePrincipal',
    MSIAuthentication: 'ManagedServiceIdentity'
};

@Metamodel.model({
    name: 'FabricWorkspace',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Fabric_Workspace_Label),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Fabric_Workspace_Label)
    ]
})
export class FabricLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly WORKSPACE_ID: IAttribute;
    public static readonly AUTHENTICATION: IAttribute;
    public static readonly TENANT: IAttribute;
    public static readonly SERVICE_PRINCIPAL_KEY: IAttribute;
    public static readonly SERVICE_PRINCIPAL_ID: IAttribute;

    @Metamodel.attribute({
        display: stringResources.WorkspaceName,
        association: 'WORKSPACE_ID',
        templatable: true
    })
    public workspaceId: string;

    @Metamodel.attribute({
        display: stringResources.Authentication,
        association: 'AUTHENTICATION',
        templatable: true
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant,
        association: 'TENANT',
        templatable: true
    })
    public tenant?: string;

    @Metamodel.attribute({
        association: 'SERVICE_PRINCIPAL_ID',
        templatable: true
    })
    public servicePrincipalId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_KEY',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalKey?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
